import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noProjectsMessage: {
		id: 'polaris-component-collection-configure-sidebar.default-content.projects-list.no-projects-message',
		defaultMessage: 'This roadmap has no projects.',
		description: 'Message displayed when no projects in the roadmap',
	},
});
